import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLandmineOpensCRUDActions } from '@mm/state/actions/LandmineOpensCRUDActions';
import { StoreState } from '@mm/state/store-interfaces';

export const useLandmineOpensHelpers = (
  landmineName: string,
  landminePlan?: string,
  bypassLadndmineGeneration = false,
) => {
  const [landmineOpenId, setLandmineOpenId] = useState<number | undefined>();
  const landmineOpensCRUDActions = useLandmineOpensCRUDActions();
  const appNavigationHistory = useSelector(
    (state: StoreState) => state.view.appNavigationHistory,
  );

  useEffect(() => {
    const sendConversionInfo = async () => {
      const res = await landmineOpensCRUDActions.create({
        landmineName,
        navigationHistory: appNavigationHistory,
        planName: landminePlan || '',
        billingOpened: false,
      });
      if (res && res.id) {
        setLandmineOpenId(res.id);
      }
    };

    if (!bypassLadndmineGeneration) {
      sendConversionInfo();
    }
  }, []);

  return {
    landmineOpenId,
    landmineOpensCRUDActions,
  };
};
